import type {
  IAffiliateGetTrackersSettingsResponse,
} from '@modules/affiliates-approved/submodules/trackers-settings/submodules/main/types';
import type { IContextMutationResult } from '@modules/core/services/query/types';
import { AFFILIATES_APPROVED_PERMISSIONS } from '@modules/affiliates-approved/constants';
import {
  AFFILIATE_GET_TRACKERS_SETTINGS_QUERY,
} from '@modules/affiliates-approved/submodules/trackers-settings/submodules/main/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { ICreateEditTrackerPayload } from '../types';
import {
  AFFILIATE_TRACKERS_SETTINGS_CREATE_EDIT_API_URL,
  AFFILIATE_TRACKERS_SETTINGS_CREATE_EDIT_MUTATION,
} from '../constants';

export default function useCreateEditTrackerMutation(): IContextMutationResult<void, Error, ICreateEditTrackerPayload> {
  const { fetchPut, fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, ICreateEditTrackerPayload>({
    mutationKey: [AFFILIATE_TRACKERS_SETTINGS_CREATE_EDIT_MUTATION],
    mutationFn: ({ id, tracker }) => (tracker.id
      ? fetchPut<void>(
          AFFILIATE_TRACKERS_SETTINGS_CREATE_EDIT_API_URL,
          tracker,
          {
            permission: AFFILIATES_APPROVED_PERMISSIONS.AFFILIATES_SHOW,
            urlParams: {
              id,
              trackerId: tracker.id,
            },
          },
        )
      : fetchPost<void>(
          AFFILIATE_TRACKERS_SETTINGS_CREATE_EDIT_API_URL,
          tracker,
          {
            permission: AFFILIATES_APPROVED_PERMISSIONS.AFFILIATES_SHOW,
            urlParams: {
              id,
              trackerId: '',
            },
          },
        )),
    onSuccess({ queryClient, variables }) {
      if (!variables.tracker.id) {
        queryClient.setQueriesData<IAffiliateGetTrackersSettingsResponse>(
          { queryKey: [AFFILIATE_GET_TRACKERS_SETTINGS_QUERY, variables.id] },
          (queryData) => {
            if (!queryData) {
              return queryData;
            }

            return {
              ...queryData,
              affiliate: {
                ...queryData.affiliate,
                trackers_count: queryData.affiliate.trackers_count + 1,
              },
            };
          },
        );
      }

      displayPresetToast(variables.tracker.id ? 'edited' : 'created');
    },
  });
}
